export const BASE_CLASS = 'mt-ListComments'
export const COMMENT_BASE_CLASS = `${BASE_CLASS}-comment`
